const selectors = {
  selectShop: '.select-shop',
}

export function resizeSelectShop() {
  const selectShops = document.querySelectorAll(selectors.selectShop);

  let primarySelectShop;

  for(const selectShop of selectShops) {
    if(selectShop.getBoundingClientRect().width > 0) {
      primarySelectShop = selectShop;
      break;
    }
  }

  if(primarySelectShop) {
    const selectShopSelect = primarySelectShop.querySelector('select');
    const selectShopOption = selectShopSelect.querySelector(`option:nth-child(${selectShopSelect.selectedIndex + 1})`);
    const ghostSelect = document.createElement('select');


    ghostSelect.innerHTML = `<option>${selectShopOption.innerHTML}</option>`
    primarySelectShop.appendChild(ghostSelect);
    document.body.style.setProperty('--selectShopMaxWidth', `${ghostSelect.getBoundingClientRect().width}px`);
    ghostSelect.remove();
  }

}
